import { render, staticRenderFns } from "./ClientDataDetails.vue?vue&type=template&id=0fc4f3f2&scoped=true&"
import script from "./ClientDataDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientDataDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDataDetails.vue?vue&type=style&index=0&id=0fc4f3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4f3f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
